// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tree-config-name[data-v-4adfdd14] {\n  margin: 0 0.13333rem;\n  font-size: 0.26667rem;\n  border: 0.02667rem solid var(--el-color-success-light-3);\n  background: var(--el-color-success-light-5);\n  color: var(--yq-font-color-tips);\n  padding: 0 0.13333rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
